/**
 * @desc 根据Names查询查询sub
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BuSbuResponseDtoRpc>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/buSub/getSubByNames`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
